"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var Button_1 = __importDefault(require("./Button"));
exports.Button = Button_1.default;
exports.default = Button_1.default;
//# sourceMappingURL=index.js.map